import { cva } from 'class-variance-authority';

export const inputSlotClasses = cva(
  'bg-white-200 rounded-lg-alt border-charcoal-alpha-50 flex h-14 w-14 cursor-text items-center gap-2 border border-solid px-2 py-3 text-center text-[16px] uppercase outline-none',
  {
    variants: {
      validationStatus: {
        true: ['border-charcoal-alpha-50 bg-white-200'],
        false: ['border-danger-500 focus:border-danger-500'],
        undefined: ['focus:border-charcoal-alpha-400 focus:bg-white-50']
      }
    },
    defaultVariants: {}
  }
);

export const wrapperClasses = 'flex w-full items-center gap-2';
